/** A2Z Camera Rentals — catalog transcribed from supplied rate sheets (Hyderabad). */

export const a2zVendor = {
  name: 'A2Z Camera Rentals',
  address: '8-2-293/k/10, Ala Enclave, Srinagar Colony, Hyderabad, Telangana',
  phone: '9703940606',
};

export const maheshPhotographyVendor = {
  name: 'Mahesh Photography and Drone Services',
  address: 'On-location services — Hyderabad, Telangana and surrounding areas',
  /** Add a reachable number when available; tel: link is hidden when empty */
  phone: '',
};

/** @typedef {{ sno: number, brand: string, item: string, price: string }} RentalRow */
/** @typedef {{ id: string, title: string, itemColumn: string, rows: RentalRow[] }} RentalCategory */

/** @type {RentalCategory[]} */
export const rentalCategories = [
  {
    id: 'cine-cameras',
    title: 'Cine cameras',
    itemColumn: 'Cameras',
    rows: [
      { sno: 1, brand: 'SONY', item: 'FX 6', price: '4000/-' },
      { sno: 2, brand: 'SONY', item: 'FX 9', price: '5000/-' },
      { sno: 3, brand: 'RED', item: 'V-Raptor-X', price: '18000/-' },
      { sno: 4, brand: 'RED', item: 'Komodo-X', price: '6000/-' },
      { sno: 5, brand: 'RED', item: 'Komodo', price: '5000/-' },
      { sno: 6, brand: 'RED', item: 'Helium', price: '6000/-' },
      { sno: 7, brand: 'ARRI', item: 'Alexa Mini', price: '8000/-' },
      { sno: 8, brand: 'ARRI', item: 'Alexa Mini LF', price: '18000/-' },
      { sno: 9, brand: 'DJI', item: 'Ronin 4D 8K', price: '15000/-' },
    ],
  },
  {
    id: 'cine-lens',
    title: 'Cine lens',
    itemColumn: 'Lens',
    rows: [
      { sno: 1, brand: 'LAOWA', item: 'Probe 24 mm', price: '1500/-' },
      { sno: 2, brand: 'ATLAS', item: 'Mercury Anamorphic (24, 36, 54, 72, 95, 138)', price: '18000/-' },
      { sno: 3, brand: 'MEIKE', item: 'Prime (16, 24, 35, 50, 85, 105, 135)', price: '4000/-' },
      { sno: 4, brand: 'COOKE', item: 'SP3 (18, 25, 32, 50, 75, 100)', price: '5000/-' },
      { sno: 5, brand: 'ZEISS', item: 'Nano Prime (18, 24, 35, 50, 75, 100)', price: '5000/-' },
      { sno: 6, brand: 'ZEISS', item: 'CP3 (15, 25, 35, 50, 85)', price: '2500/-' },
      { sno: 7, brand: 'ZEISS', item: 'Suprem Prime (25, 35, 50, 85, 135)', price: '10000/-' },
      { sno: 8, brand: 'SIGMA', item: 'Cine Prime (14, 20, 24, 35, 50, 85, 135)', price: '5000/-' },
      { sno: 9, brand: 'ARRI', item: 'Ultra Prime (16, 24, 32, 50, 85)', price: '4000/-' },
      { sno: 10, brand: 'ARRI', item: 'Alura Zoom (45 - 250 mm)', price: '3000/-' },
      { sno: 11, brand: 'ANGENIEUX', item: 'HR Zoom (25 - 250 mm)', price: '1000/-' },
    ],
  },
  {
    id: 'dslr-cameras',
    title: 'DSLR cameras',
    itemColumn: 'Cameras',
    rows: [
      { sno: 1, brand: 'SONY', item: 'A7 M III', price: '1000/-' },
      { sno: 2, brand: 'SONY', item: 'A7 M IV', price: '2000/-' },
      { sno: 3, brand: 'SONY', item: 'A7 M V', price: '2500/-' },
      { sno: 4, brand: 'SONY', item: 'A7S III', price: '2000/-' },
      { sno: 5, brand: 'SONY', item: 'A7 R III', price: '1200/-' },
      { sno: 6, brand: 'SONY', item: 'A7 R IV', price: '1500/-' },
      { sno: 7, brand: 'SONY', item: 'A7R V', price: '2500/-' },
      { sno: 8, brand: 'SONY', item: 'FX 3', price: '2500/-' },
      { sno: 9, brand: 'SONY', item: 'Z150 4K Camrecoder', price: '1500/-' },
      { sno: 10, brand: 'CANON', item: '5D Mark IV', price: '1000/-' },
      { sno: 11, brand: 'CANON', item: 'EOS C50', price: '2500/-' },
      { sno: 12, brand: 'CANON', item: 'EOS R5 M II', price: '2500/-' },
      { sno: 13, brand: 'CANON', item: 'EOS R6 MIII', price: '2500/-' },
      { sno: 14, brand: 'NIKON', item: 'Z6 II', price: '1500/-' },
      { sno: 15, brand: 'NIKON', item: 'Z6 III', price: '2000/-' },
      { sno: 16, brand: 'NIKON', item: 'Z7 II', price: '2000/-' },
      { sno: 17, brand: 'NIKON', item: 'Z8', price: '2500/-' },
      { sno: 18, brand: 'NIKON', item: 'Z9', price: '3000/-' },
      { sno: 19, brand: 'NIKON', item: 'ZR', price: '2000/-' },
    ],
  },
  {
    id: 'e-mount-lens',
    title: 'E mount lens',
    itemColumn: 'Lens',
    rows: [
      { sno: 1, brand: 'SONY', item: '14 mm GM f/1.8', price: '1000/-' },
      { sno: 2, brand: 'SONY', item: '16 mm GM f/1.8', price: '1000/-' },
      { sno: 3, brand: 'SONY', item: '24 mm GM f/1.4', price: '1000/-' },
      { sno: 4, brand: 'SIRUI', item: '35 mm Macro', price: '1500/-' },
      { sno: 5, brand: 'SONY', item: '35 mm GM f/1.4', price: '1000/-' },
      { sno: 6, brand: 'SONY', item: '50 mm GM f/1.2', price: '1000/-' },
      { sno: 7, brand: 'SONY', item: '50 mm GM f/1.4', price: '1000/-' },
      { sno: 8, brand: 'SONY', item: '50 mm GM f/1.8', price: '500/-' },
      { sno: 9, brand: 'SONY', item: '85 mm GM I f/1.4', price: '1000/-' },
      { sno: 10, brand: 'SONY', item: '85 mm GM II f/1.4', price: '1000/-' },
      { sno: 11, brand: 'SONY', item: '90 mm Macro f/2.8', price: '1000/-' },
      { sno: 12, brand: 'SONY', item: '135 mm GM f/1.8', price: '1200/-' },
      { sno: 13, brand: 'SONY', item: '12-24 mm GM f/2.8', price: '1200/-' },
      { sno: 14, brand: 'SONY', item: '16 - 35 mm GM I f/2.8', price: '1000/-' },
      { sno: 15, brand: 'SONY', item: '16 - 35 mm GM II f/2.8', price: '1000/-' },
      { sno: 16, brand: 'SONY', item: '24 - 70 mm GM I f/2.8', price: '1000/-' },
      { sno: 17, brand: 'SONY', item: '24 - 70 mm GM II f/2.8', price: '1000/-' },
      { sno: 18, brand: 'SONY', item: '24 - 105 mm f/4', price: '600/-' },
      { sno: 19, brand: 'SONY', item: '28 - 70 mm f/2', price: '1000/-' },
      { sno: 20, brand: 'SONY', item: '28-135 mm f/4', price: '500/-' },
      { sno: 21, brand: 'SONY', item: '50-150 mm GM f/2', price: '1500/-' },
      { sno: 22, brand: 'SONY', item: '70 - 200 mm GM I f/2.8', price: '1000/-' },
      { sno: 23, brand: 'SONY', item: '70 - 200 mm GM II f/2.8', price: '1000/-' },
      { sno: 24, brand: 'SONY', item: '200 - 600 mm GM f/5.6-6.3', price: '1500/-' },
    ],
  },
  {
    id: 'nikon-z-lens',
    title: 'Nikon Z mount lens',
    itemColumn: 'Lens',
    rows: [
      { sno: 1, brand: 'NIKON', item: '35mm f/1.8', price: '500/-' },
      { sno: 2, brand: 'NIKON', item: '35mm f/1.4', price: '800/-' },
      { sno: 3, brand: 'NIKON', item: '50mm f/1.2', price: '1200/-' },
      { sno: 4, brand: 'NIKON', item: '50mm f/1.4', price: '800/-' },
      { sno: 5, brand: 'NIKON', item: '50mm f/1.8', price: '500/-' },
      { sno: 6, brand: 'NIKON', item: '85mm f/1.2', price: '1200/-' },
      { sno: 7, brand: 'NIKON', item: '85mm f/1.8', price: '500/-' },
      { sno: 8, brand: 'NIKON', item: '17-28mm f/2.8', price: '1200/-' },
      { sno: 9, brand: 'NIKON', item: '24-70mm f/2.8', price: '1200/-' },
      { sno: 10, brand: 'NIKON', item: '24-70mm f/4', price: '500/-' },
      { sno: 11, brand: 'NIKON', item: '24-120mm f/4', price: '500/-' },
      { sno: 12, brand: 'NIKON', item: '28-75mm f/2.8', price: '1200/-' },
      { sno: 13, brand: 'NIKON', item: '70-200mm f/2.8', price: '1200/-' },
      { sno: 14, brand: 'NIKON', item: '180-600mm f/5.6', price: '1500/-' },
    ],
  },
  {
    id: 'canon-rf-lens',
    title: 'Canon RF mount lens',
    itemColumn: 'Lens',
    rows: [
      { sno: 1, brand: 'CANON', item: '35mm f/1.4', price: '1000/-' },
      { sno: 2, brand: 'CANON', item: '35mm f/1.8', price: '500/-' },
      { sno: 3, brand: 'CANON', item: '50mm f/1.2', price: '1200/-' },
      { sno: 4, brand: 'CANON', item: '50mm f/1.4', price: '1000/-' },
      { sno: 5, brand: 'CANON', item: '50mm f/1.8', price: '500/-' },
      { sno: 6, brand: 'CANON', item: '85mm f/1.2', price: '1200/-' },
      { sno: 7, brand: 'CANON', item: '85mm f/1.4', price: '1000/-' },
      { sno: 8, brand: 'CANON', item: '100mm macro', price: '1000/-' },
      { sno: 9, brand: 'CANON', item: '15 - 35 mm f/2.8', price: '1200/-' },
      { sno: 10, brand: 'CANON', item: '24 - 70 mm f/2.8', price: '1200/-' },
      { sno: 11, brand: 'CANON', item: '24 - 105 mm f/4', price: '500/-' },
      { sno: 12, brand: 'CANON', item: '70 - 200 mm f/2.8', price: '1200/-' },
      { sno: 13, brand: 'CANON', item: '200 - 800 mm f/6.3', price: '1500/-' },
    ],
  },
  {
    id: 'drones',
    title: 'Drones',
    itemColumn: 'Cameras',
    rows: [
      { sno: 1, brand: 'DJI', item: 'DJI Air 3s With Operator', price: '6000/-' },
      { sno: 2, brand: 'DJI', item: 'Mavic 3 With Operator', price: '8000/-' },
    ],
  },
  {
    id: 'action-cameras',
    title: 'Action cameras',
    itemColumn: 'Cameras',
    rows: [
      { sno: 1, brand: 'GOPRO', item: 'Hero 13', price: '1500/-' },
      { sno: 2, brand: 'GOPRO', item: 'Hero 12', price: '1000/-' },
      { sno: 3, brand: 'INSTA', item: '360 X4', price: '2000/-' },
    ],
  },
  {
    id: 'gimbals',
    title: 'Gimbals',
    itemColumn: 'Gimbals',
    rows: [
      { sno: 1, brand: 'DJI', item: 'RS IV PRO', price: '2000/-' },
      { sno: 2, brand: 'DJI', item: 'RS IV', price: '1500/-' },
      { sno: 3, brand: 'DJI', item: 'RS III PRO', price: '1500/-' },
      { sno: 4, brand: 'Tilta', item: "Advanced RIG for DJI Gimbal's", price: '1500/-' },
      { sno: 5, brand: 'ZHIYUN', item: 'Crane III S', price: '1500/-' },
    ],
  },
  {
    id: 'raw-recorders',
    title: 'Raw recorders',
    itemColumn: "Raw recorder's",
    rows: [
      { sno: 1, brand: 'SMALL HD', item: 'SMALL HD (7" Inches)', price: '1500/-' },
      { sno: 2, brand: 'ATOMOS', item: 'Shogun Ultra (7" Inches)', price: '1500/-' },
      { sno: 3, brand: 'ATOMOS', item: 'Shogun Inferno (7" Inches)', price: '1000/-' },
      { sno: 4, brand: 'ATOMOS', item: 'Ninja V (5" Inches)', price: '1000/-' },
    ],
  },
  {
    id: 'photo-lights',
    title: 'Photo lights',
    itemColumn: 'Lights',
    rows: [
      { sno: 1, brand: 'GODEX', item: 'AD 600 Pro II', price: '1500/-' },
      { sno: 2, brand: 'GODEX', item: 'AD 600 Pro', price: '1500/-' },
      { sno: 3, brand: 'GODEX', item: 'AD 400 Pro', price: '1200/-' },
      { sno: 4, brand: 'GODEX', item: 'AD300 Pro', price: '1000/-' },
      { sno: 5, brand: 'GODEX', item: 'AD 200', price: '800/-' },
    ],
  },
  {
    id: 'video-lights',
    title: 'Video lights',
    itemColumn: 'Lights',
    rows: [
      { sno: 1, brand: 'NANLITE', item: '2 Feet RGB Tube', price: '500/-' },
      { sno: 2, brand: 'NANLITE', item: '4 Feet RGB Tube', price: '800/-' },
      { sno: 3, brand: 'NANLITE', item: '60 B (BI - COLOUR)', price: '800/-' },
      { sno: 4, brand: 'NANLITE', item: '300 B (BI - COLOUR)', price: '1000/-' },
      { sno: 5, brand: 'NANLITE', item: '300 C (RGB - COLOUR)', price: '1200/-' },
      { sno: 6, brand: 'NANLITE', item: '720 B (BI - COLOR)', price: '2000/-' },
      { sno: 7, brand: 'NANLITE', item: 'Spot Mount', price: '1000/-' },
      { sno: 8, brand: 'GODEX', item: 'LC 500 R', price: '500/-' },
      { sno: 9, brand: 'GODEX', item: 'LC1000 R', price: '800/-' },
      { sno: 10, brand: 'DIGITEK', item: 'DIGITEK 200 RGB', price: '600/-' },
      { sno: 11, brand: 'DIGITEK', item: 'DIGITEK 600(BI - COLOR)', price: '1500/-' },
      { sno: 12, brand: 'APUTURE', item: 'MC 4 Kit', price: '1000/-' },
      { sno: 13, brand: 'APUTURE', item: 'Amron 200 X', price: '1000/-' },
      { sno: 14, brand: 'APUTURE', item: 'Aputure 300 X', price: '1000/-' },
      { sno: 15, brand: 'APUTURE', item: 'Aputure 600 LS', price: '1500/-' },
      { sno: 16, brand: 'APUTURE', item: 'Nova P 300 C (SKY PANEL)', price: '1500/-' },
    ],
  },
  {
    id: 'accessories',
    title: "Accessories",
    itemColumn: 'Accessories details',
    rows: [
      { sno: 1, brand: 'KODAK, PANASONIC, LILLIPUT', item: 'Director Monitor', price: '1000/-' },
      { sno: 2, brand: 'TELIPROMPTER', item: 'Reading Monitor with Operator', price: '6000/-' },
      { sno: 3, brand: 'ARRI', item: 'CMOTION Follow Focus', price: '2000/-' },
      { sno: 4, brand: 'NUCLUES M', item: 'Wireless Follow Focus', price: '1000/-' },
      { sno: 5, brand: 'NUCLUES N', item: 'Wireless Follow Focus', price: '500/-' },
      { sno: 6, brand: 'HOLLYLAND', item: 'Pyro H', price: '500/-' },
      { sno: 7, brand: 'HOLLYLAND', item: 'Pyro S & Cosmo C1', price: '1000/-' },
      { sno: 8, brand: 'SLIDER', item: '5 feet', price: '500/-' },
      { sno: 9, brand: 'SLIDER', item: '10 feet', price: '1000/-' },
      { sno: 10, brand: 'DJI', item: 'DJI Wirless Mic 2', price: '500/-' },
      { sno: 11, brand: 'Rode', item: 'Wireless Mic', price: '500/-' },
      { sno: 12, brand: 'ZOOM', item: 'Pod Cast Mics', price: '1000/-' },
      { sno: 13, brand: 'Occoner', item: 'Heavy Tripod', price: '500/-' },
      { sno: 14, brand: 'E- Image', item: 'Tripod', price: '300/-' },
      { sno: 15, brand: 'Manfrotto', item: 'Photo Tripod', price: '500/-' },
      { sno: 16, brand: 'Grip Equipment', item: 'Boom Stand', price: '200/-' },
      { sno: 17, brand: 'Grip Equipment', item: 'Flags', price: '200/-' },
      { sno: 18, brand: 'Grip Equipment', item: 'Reflectors', price: '200/-' },
    ],
  },
];

/** Spotlight cards for the landing “Production sourcing” strip */
export const sourcingSpotlightItems = [
  { icon: '📷', title: 'RED Komodo', price: '₹5,000/day' },
  { icon: '📷', title: 'Sony FX6', price: '₹4,000/day' },
  { icon: '🚁', title: 'DJI Mavic 3 + operator', price: '₹8,000/day' },
  { icon: '🔭', title: 'Atlas Mercury Anamorphic', price: '₹18,000/day' },
  { icon: '💡', title: 'Aputure 600 LS', price: '₹1,500/day' },
];

/** Vendors shown on /production-sourcing — card opens full rate catalog */
export const equipmentVendors = [
  {
    id: 'a2z',
    catalogPath: '/equipment-rentals',
    name: a2zVendor.name,
    address: a2zVendor.address,
    phone: a2zVendor.phone,
    city: 'Hyderabad',
    region: 'Telangana',
    icon: '📷',
    summary:
      'Cine cameras, cine & DSLR lenses, E / Nikon Z / RF mounts, drones, action cameras, gimbals, recorders, photo & video lights, and accessories — Hyderabad.',
    cta: 'View full catalog →',
  },
  {
    id: 'mahesh-photography-drone',
    catalogPath: '/mahesh-photography-drone-services',
    name: maheshPhotographyVendor.name,
    address: maheshPhotographyVendor.address,
    phone: maheshPhotographyVendor.phone,
    city: 'Hyderabad',
    region: 'Telangana',
    icon: '🚁',
    summary:
      'Photography and aerial drone services for productions, events, and promotional content — book directly for crew and permits.',
    cta: 'View details →',
  },
];
